import React, { useCallback, useEffect, useState } from "react";

import { Stack } from "@churchofjesuschrist/eden-stack";

import alertSessionMemory from "../alert-session-memory";
import SystemAlertUserDisplay from "../system-alert-user-display/system-alert-user-display";

const sessionForgetAlert = (alert) => {
  alertSessionMemory.forget(alert);
};

const BannerAlertsManager = (props) => {
  const { alerts: propAlerts, onRemoveAlert = () => {} } = props;

  const [alerts, setAlerts] = useState(propAlerts);
  useEffect(() => {
    setAlerts(propAlerts);
  }, [propAlerts]);

  const onDismiss = useCallback(
    (alert) => {
      sessionForgetAlert(alert);
      setAlerts([...alerts]);
      //we do this just to notify the parent context so
      //places like the alert counter on the top bar can change
      onRemoveAlert({ alert: alert, action: "hide" });
    },
    [alerts, onRemoveAlert]
  );
  const onDelete = useCallback(
    (alert) => {
      //we can safely forget this alert since it is now going to be deleted
      //that's the simplest way to get it out of the UI while we wait for the delete to run.
      sessionForgetAlert(alert);
      setAlerts([...alerts]);
      //this one is needed so a higher context can actually do a data call
      onRemoveAlert({ alert: alert, action: "delete" });
    },
    [onRemoveAlert, alerts]
  );

  const showAlerts = alertSessionMemory.filter(alerts);
  return (
    <Stack gapSize="0">
      {showAlerts.map((a) => (
        <SystemAlertUserDisplay
          alert={a}
          key={a.id}
          onDismiss={onDismiss}
          onDelete={onDelete}
        />
      ))}
    </Stack>
  );
};

export default BannerAlertsManager;
